// import React, { useState } from 'react';
// import { Grid, IconButton, Box, Typography } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// const FileUploadPreview = ({ selectedFiles, deleteFile }) => {
//   const [file, setFile] = useState([]);
//   const [preview, setPreview] = useState(null);

//   const handlePreview = (file) => {
//     const reader = new FileReader();
//     reader.onload = () => {
//       setPreview(reader.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   function uploadSingleFile(e) {
//     let ImagesArray = Object.entries(e.target.files).map((e) => URL.createObjectURL(e[1]));
//     setFile([...file, ...ImagesArray]);
//   }

//   function upload(e) {
//     e.preventDefault();
//     console.log(file);
//   }

//   // function deleteFile(e) {
//   //   const s = file.filter((item, index) => index !== e);
//   //   setFile(s);
//   //   console.log(s);
//   // }

//   return (
//     < div>
//       {/* <Form.Control type="file" multiple onChange={uploadSingleFile} accept={docType} /> */}

//       <Grid container spacing={2}>
//         {selectedFiles?.map((file, index) => (
//           <Grid item key={index} xs={3} md={3} className="d-flex align-items-start choose-file">
//             {file.type.startsWith('image/') ? (
//               <Box className="ms-2 choose-img">
//                 <img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100%' }} />
//               </Box>
//             ) : (
//               // <Typography>{file?.name}</Typography>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   whiteSpace: 'nowrap',
//                   overflow: 'visible',
//                   textOverflow: 'unset',
//                 }}
//               >
//                 {file?.name}
//               </Typography>

//             )}
//             <Box className="image-position">
//               <IconButton onClick={() => deleteFile(index)} className="close-icon" aria-label="Hide">
//                 <CloseIcon sx={{ marginTop: '-8px' }} />
//               </IconButton>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </div >

//   );
// };

// export default FileUploadPreview;

// FileUploadPreview/index.jsx

import React from 'react';
import { Grid, IconButton, Box, Typography, Chip, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CommonBadges from '../Badges';

const formatBytes = (bytes) => {
  if (bytes === 0) return '0 B';
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const val = bytes / Math.pow(1024, i);
  return `${i === 0 ? val.toFixed(0) : val.toFixed(2)} ${sizes[i]}`;
};

const centerTruncate = (str, max = 28) => {
  if (!str || str.length <= max) return str;
  const half = Math.floor((max - 3) / 2);
  return `${str.slice(0, half)}...${str.slice(-half)}`;
};

const getTypeLabel = (mime = '') => {
  if (mime.startsWith('image/')) return 'Image';
  if (mime.startsWith('video/')) return 'Video';
  if (mime.startsWith('audio/')) return 'Audio';
  return 'Document';
};
const getPreviewEmoji = (mime = '') =>
  mime.startsWith('image/')
    ? '🖼️'
    : mime.startsWith('video/')
      ? '🎬'
      : mime.startsWith('audio/')
        ? '🎵'
        : '📄';

const FileUploadPreview = ({ selectedFiles = [], deleteFile }) => {
  if (!selectedFiles?.length) return null;

  return (
   <Box sx={{ mx: 2, mb: 1 /* no bg, no border here */ }}>
  <Grid container spacing={2} pl="16px" pt="0px !important" mb="10px">
    {selectedFiles?.map((file, index) => {
      const typeLabel = getTypeLabel(file.type);
      const size = formatBytes(file.size);
      const isImage = file.type?.startsWith("image/");
      const thumbSrc = isImage ? URL.createObjectURL(file) : null;

      return (
        <Grid
          item
          key={index}
          xs={3}
          md={3}
          className="d-flex align-items-start choose-file pt-0 ps-0"
        >
          {/* {isImage ? (
            <Box
              className="ms-2 choose-img upload-img"
              sx={{ backgroundColor: "#fff" }}
            >
              <img
                src={thumbSrc}
                alt={file.name}
                style={{ width: "100%" }}
              />
            </Box>
          ) : ( */}
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                border: "1px solid #E5E7EB",
                borderRadius: "12px",
                p: 1,
                background: "#fff",
              }}
            >
              {/* File thumbnail or emoji */}
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "10px",
                  background: "#F6F8FF",
                  border: "1px solid #C9D2FF",
                  display: "grid",
                  placeItems: "center",
                  overflow: "hidden",
                  flex: "0 0 auto",
                }}
              >
                {isImage ? (
                  <img
                    src={thumbSrc ?? ""}
                    alt={file.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography component="span" sx={{ fontSize: 20 }}>
                    {getPreviewEmoji(file.type)}
                  </Typography>
                )}
              </Box>

              {/* File info */}
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Tooltip title={file.name}>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{ fontWeight: 600, color: "#0f172a" }}
                  >
                    {centerTruncate(file.name)}
                  </Typography>
                </Tooltip>
                <Typography variant="caption" sx={{ color: "#6b7280" }}>
                  {typeLabel} • {size}
                </Typography>
              </Box>

              {/* Actions */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <CommonBadges
                  size="small"
                  value={typeLabel}
                  color='primary'
                  variant='outlined'
                  // sx={{
                  //   bgcolor: "#F6F8FF",
                  //   border: "1px solid #C9D2FF",
                  //   color: "#1631B1",
                  //   height: 22,
                  // }}
                />
                <IconButton
                  size="small"
                  onClick={() => deleteFile(index)}
                  aria-label="Remove file"
                  sx={{
                    border: "1px solid #e5e7eb",
                    width: 28,
                    height: 28,
                    "&:hover": { background: "#f9fafb" },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </Typography>
          {/* )} */}
        </Grid>
      );
    })}
  </Grid>
</Box>

  );
};

export default FileUploadPreview;
